import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { PermissionService } from '../services/permission.service';
import { UserService } from '../services/user.service';
import { AuthenticateService } from '../services/authenticate.service';
import { lastValueFrom } from 'rxjs';

let authProfilePromise: Promise<boolean> | null = null;

export const authGuard: CanActivateFn = async (route, state) => {
    const router = inject(Router);
    const permissionService = inject(PermissionService);
    const userService = inject(UserService);
    const authService = inject(AuthenticateService);

    const token = localStorage.getItem('access_token');

    if (!token) {
        router.navigate(['/login']);
        return false;
    }

    // 為了防止父路由和子路由在同一次導頁時重複呼叫 API，這裡使用 Promise cache 機制
    if (!authProfilePromise) {
        authProfilePromise = (async () => {
            try {
                const res = await lastValueFrom(authService.apiGetAuthProfile());

                const profileData = res.data;
                if (profileData && profileData.role && profileData.role.permissions) {
                    userService.setProfile(profileData);
                    permissionService.setPermissions(profileData.role.permissions);
                    return true;
                }
                localStorage.removeItem('access_token');
                permissionService.clearPermissions();
                userService.clearProfile();
                router.navigate(['/login']);
                return false;

            } catch (error) {
                localStorage.removeItem('access_token');
                permissionService.clearPermissions();
                userService.clearProfile();
                router.navigate(['/login']);
                return false;
            } finally {
                // 等待 100ms 後清空 Cache，讓下一次不同的路由切換可以再次真實觸發 API
                setTimeout(() => authProfilePromise = null, 100);
            }
        })();
    }

    return authProfilePromise;
};
